import { Css, useTestIds } from "@homebound/beam";
import { formatCentsToPrice } from "src/utils";

/** Which of an option's amounts a card shows: what the customer pays, or what it costs us. */
export enum OptionPriceMode {
  Price = "price",
  Cost = "cost",
}

/** The amount a card shows for an option under `priceMode`. */
export function optionAmountInCents(
  o: { totalPriceInCents: number; totalCostInCents: number },
  priceMode: OptionPriceMode,
): number {
  return priceMode === OptionPriceMode.Cost ? o.totalCostInCents : o.totalPriceInCents;
}

type FormatOptionPriceOpts = { displayDirection?: boolean; trim?: boolean };

/**
 * Mirrors checkout's `formatDeltaPriceDisplay`: an option's price is the delta over its group's included option, so
 * zero reads as "Included" rather than "$0". Anything else is formatted as the caller asks, since not every page
 * signs its prices.
 */
export function formatOptionPrice(priceInCents: number, opts: FormatOptionPriceOpts = {}): string {
  return priceInCents === 0 ? "Included" : formatCentsToPrice(priceInCents, opts);
}

type OptionPriceProps = FormatOptionPriceOpts & { priceInCents: number };

/** `formatOptionPrice` as an element, with "Included" de-emphasized the way checkout shows it. */
export function OptionPrice(props: OptionPriceProps) {
  const { priceInCents, ...opts } = props;
  const tid = useTestIds(props, "price");
  return (
    <span css={Css.wsnw.if(priceInCents === 0).gray600.$} {...tid}>
      {formatOptionPrice(priceInCents, opts)}
    </span>
  );
}
